export const validValuesToItems = (validValues, separator) => {
  const texts = validValues.text.split(separator);
  const values = validValues.value.split(separator);
  return texts.map((x, i) => ({ text: x, value: values[i] }));
};
